import { render, staticRenderFns } from "./paymentDetails.vue?vue&type=template&id=6613e175&scoped=true"
import script from "./paymentDetails.vue?vue&type=script&lang=js"
export * from "./paymentDetails.vue?vue&type=script&lang=js"
import style0 from "./paymentDetails.vue?vue&type=style&index=0&id=6613e175&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6613e175",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6613e175')) {
      api.createRecord('6613e175', component.options)
    } else {
      api.reload('6613e175', component.options)
    }
    module.hot.accept("./paymentDetails.vue?vue&type=template&id=6613e175&scoped=true", function () {
      api.rerender('6613e175', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/institutionalWalletChild/child/paymentDetails.vue"
export default component.exports